export default "<p>\n  eternal-app works!\n</p>\n"